import { styled } from '@mui/material/styles'
import { TextField } from '@mui/material'

export const InputForm = styled(TextField)({
    width: '100%',

    '& label.Mui-focused': {
        color: '#A69478',
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: '#707070',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#A69478',
        },
    },
})
